import { SolutionsByQuestionId } from '@/models/undergrad/services/dex.services.model';
import { ReplyType, SolutionType } from '@/models/undergrad/services/lessons-reader.model';
import { DexReplyResponse } from '@/services/undergrad/pegasus-pepe-legal/exercises-evaluation.service';

export function normalizeReply(reply: DexReplyResponse): {
  reply: ReplyType;
  solutions: SolutionType[];
} {
  const {
    questionByQuestionId: { solutionsByQuestionIdList },
  } = reply;

  return {
    reply: { id: reply.id, alternativeId: reply.alternativeId },
    solutions: solutionsByQuestionIdList.map((solution: SolutionsByQuestionId) => {
      const solutionContents = solution.contentsBySolutionIdList
        .sort((a, b) => a.position - b.position)
        .map((content) => ({
          text: content.textByTextId?.body,
          image: content.imageByImageId,
          video: content.videoByVideoId,
        }));

      return {
        id: solution.id,
        user: solution.userByUserId,
        contents: solutionContents,
      };
    }),
  };
}
